import MyContract from '../features/merchants/MyContract';

export const MyContractPage = () => <MyContract />;
